import React, { FC } from "react";
import { HTML_TEMPLATES } from "../../helpers/contants";
import { vwDesktop, vwMobile } from "../../helpers/styles";
import { BREAKPOINTS } from "../../helpers/theme";
import styled from "styled-components";
import { PlainHtml } from "../PlainHtml";
import ReactPlayer from "react-player";
import AppendHtml from "../AppendHtml";
import ButtonLink, {
  ButtonType,
} from "../shared/ButtonLink";

export type DynamicHtmlSectionProps = {
  template?: HTML_TEMPLATES;
  content?: string;
  backgroundColor?: string;
  videoUrl?: string;
  unsafeCode?: string;
  buttonLabel?: string;
  buttonLink?: string;
};

export const HtmlContainer = styled.div<{
  backgroundColor?: string;
  template?: HTML_TEMPLATES;
}>`
  padding: ${vwMobile(40)} ${vwMobile(18)};
  background-color: ${(p) =>
    p.backgroundColor ?? "var(--color-green-90)"};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: ${({ template }) =>
      template === HTML_TEMPLATES.PLAIN_HTML_TYPE_1
        ? `${vwDesktop(80)} ${vwDesktop(150)} ${vwDesktop(
            80,
          )}`
        : `${vwDesktop(80)} ${vwDesktop(310)}`};
  }
`;

export const StyledReactPlayer = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100% !important;
  height: 100% !important;
`;

export const ReactPlayerContainer = styled.div`
  width: 100%;
  padding-top: 56.25%;
  position: relative;
  margin-bottom: ${vwMobile(77)};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    margin-bottom: 0;
  }
`;

export const ButtonLinkContainer = styled.div`
  margin-top: ${vwMobile(40)};
  display: flex;
  justify-content: center;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    margin-top: ${vwDesktop(40)};
  }
`;

export const DynamicHtmlSection: FC<DynamicHtmlSectionProps> =
  ({
    template,
    content,
    backgroundColor,
    videoUrl,
    unsafeCode,
    buttonLabel,
    buttonLink,
  }: DynamicHtmlSectionProps) => {
    let className;

    switch (backgroundColor?.toLowerCase()) {
      case "#7a3818":
        className = "bg-color-dark-green";
        break;

      case "#75c154":
        className = "bg-color-butterleaf";
        break;

      default:
        className = "bg-color-linen";
        break;
    }

    return (
      <HtmlContainer
        className={className}
        template={template}
        backgroundColor={backgroundColor}
      >
        <PlainHtml content={content} />
        {videoUrl && (
          <ReactPlayerContainer>
            <StyledReactPlayer url={videoUrl} />
          </ReactPlayerContainer>
        )}
        {unsafeCode && <AppendHtml html={unsafeCode} />}
        {buttonLabel && buttonLink && (
          <ButtonLinkContainer>
            <ButtonLink
              type={ButtonType.YELLOW}
              label={buttonLabel}
              link={buttonLink}
            />
          </ButtonLinkContainer>
        )}
      </HtmlContainer>
    );
  };
